import { render, staticRenderFns } from "./wsa-button.vue?vue&type=template&id=1ba79905"
import script from "./wsa-button.vue?vue&type=script&lang=ts"
export * from "./wsa-button.vue?vue&type=script&lang=ts"
import style0 from "./wsa-button.vue?vue&type=style&index=0&id=1ba79905&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports